import React from 'react'
import { useFormContext } from 'react-hook-form'

import { useBrandAccountQueryBrandAccount } from '~/hooks/useBrandAccountQuery'
import { findByPath } from '~/utils'

import { type InputValues } from '../utils'

export const useSurvey = () => {
  const brandAccount = useBrandAccountQueryBrandAccount()
  const { watch } = useFormContext<InputValues>()
  const surveyId = watch('surveyId')

  return React.useMemo(
    () => findByPath(brandAccount.surveys, 'id', surveyId),
    [brandAccount.surveys, surveyId],
  )
}
